(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-adeqo-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Scroll-state: glass-blur alleen bovenaan, effen wit tijdens scrollen (scroll-performance)
  (function() {
    var headerEl = document.querySelector('.header-adeqo');
    if (headerEl) {
      var ticking = false;
      var setState = function() {
        headerEl.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 10);
        ticking = false;
      };
      window.addEventListener('scroll', function() {
        if (!ticking) { requestAnimationFrame(setState); ticking = true; }
      }, { passive: true });
      setState();
    }
  })();

  // Dropdown-, mobiel-menu-, submenu- en search-logica (incl. de body-appendChild
  // die het mobiele menu uit de sticky/blur-header tilt) staat in het inline <script>
  // bovenaan deze sectie. NIET hier dupliceren: dubbele click-listeners op een toggle
  // heffen elkaar op → "klik doet niks". Dit blok houdt alleen de scroll-state.
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
(function() {
  // Custom element for search drawer
  if (customElements.get('search-drawer')) return;

  class SearchDrawer extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.adeqo-search-drawer__overlay');
      this.closeBtn = this.querySelector('.adeqo-search-drawer__close-floating');
      this.panel = this.querySelector('.adeqo-search-drawer__panel');
      this.input = this.querySelector('.adeqo-search-drawer__input');
      this.clearBtn = this.querySelector('.adeqo-search-drawer__clear');
      this.idleContent = this.querySelector('[data-search-idle]');
      this.resultsContainer = this.querySelector('[data-search-results]');
      this.resultsList = this.querySelector('[data-results-list]');
      this.loadingState = this.querySelector('[data-search-loading]');
      this.bestsellersColumn = this.querySelector('[data-bestsellers-column]');
      this.viewAllBtn = this.querySelector('[data-view-all]');
      this.sectionId = this.dataset.sectionId;

      this.debounceTimer = null;
      this.isMouseOutsidePanel = false;
      this.bindEvents();

      // Handle Shopify Theme Editor events
      if (this.hasAttribute('handle-section-events')) {
        this.bindDesignModeEvents();
      }
    }

    bindEvents() {
      // Close on overlay click
      this.overlay?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });

      // Close button
      this.closeBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });

      // Clear button
      this.clearBtn?.addEventListener('click', () => {
        if (this.input) {
          this.input.value = '';
          this.input.focus();
          this.showIdleState();
        }
      });

      // Input changes
      this.input?.addEventListener('input', (e) => this.onInputChange(e));

      // Tag clicks
      this.querySelectorAll('.adeqo-search-drawer__tag').forEach(tag => {
        tag.addEventListener('click', (e) => {
          e.preventDefault();
          const term = tag.dataset.searchTerm;
          if (this.input && term) {
            this.input.value = term;
            this.performSearch(term);
          }
        });
      });

      // Mouse tracking for floating close button
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundMouseLeave = this.handleMouseLeave.bind(this);
    }

    handleMouseMove(e) {
      if (!this.panel || !this.closeBtn) return;

      const panelRect = this.panel.getBoundingClientRect();
      const mouseX = e.clientX;
      const mouseY = e.clientY;

      // Check if mouse is outside the panel
      const isOutside =
        mouseX < panelRect.left ||
        mouseX > panelRect.right ||
        mouseY < panelRect.top ||
        mouseY > panelRect.bottom;

      if (isOutside) {
        // Position the close button at mouse position
        // De root heeft `zoom` (site 10% compacter op desktop, min-width 1200px).
        // position:fixed wordt door die zoom geschaald, terwijl clientX/Y in de
        // visuele ruimte zitten — dus deel door de zoomfactor en centreer (-22 = halve 44px).
        const zoom = parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
        this.closeBtn.style.left = `${mouseX / zoom - 22}px`;
        this.closeBtn.style.top = `${mouseY / zoom - 22}px`;
        this.closeBtn.classList.add('is-visible');
        this.isMouseOutsidePanel = true;
      } else {
        this.closeBtn.classList.remove('is-visible');
        this.isMouseOutsidePanel = false;
      }
    }

    handleMouseLeave() {
      if (this.closeBtn) {
        this.closeBtn.classList.remove('is-visible');
      }
      this.isMouseOutsidePanel = false;
    }

    bindDesignModeEvents() {
      // Open when section is selected in Theme Editor
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.open();
        }
      });

      // Close when section is deselected in Theme Editor
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.close();
        }
      });

      // Handle block selection (if any blocks exist)
      document.addEventListener('shopify:block:select', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.open();
        }
      });

      document.addEventListener('shopify:block:deselect', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.close();
        }
      });
    }

    open(fromMenu = false) {
      // If opening from mobile menu, add morphing class
      if (fromMenu && window.innerWidth < 768) {
        this.classList.add('from-mobile-menu');
        this.classList.remove('morph-complete');
      }

      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-drawer-open');
      setTimeout(() => this.input?.focus(), 100);

      // Start mouse tracking (desktop only)
      if (window.innerWidth >= 768) {
        document.addEventListener('mousemove', this.boundMouseMove);
        document.addEventListener('mouseleave', this.boundMouseLeave);
      }

      // After animation completes, switch to normal transitions
      if (fromMenu && window.innerWidth < 768) {
        setTimeout(() => {
          this.classList.add('morph-complete');
          this.classList.remove('from-mobile-menu');
        }, 400);
      }
    }

    // Special method for opening from mobile menu with morphing animation
    openFromMenu() {
      this.open(true);
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-drawer-open');
      // Reset
      if (this.input) this.input.value = '';
      this.showIdleState();

      // Remove morphing classes
      this.classList.remove('from-mobile-menu', 'morph-complete');

      // Stop mouse tracking and hide floating button
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('mouseleave', this.boundMouseLeave);
      if (this.closeBtn) {
        this.closeBtn.classList.remove('is-visible');
      }
    }

    onInputChange(e) {
      const query = e.target.value.trim();

      // Update view all button URL
      if (this.viewAllBtn) {
        this.viewAllBtn.href = query.length > 0
          ? window.theme.url(`/search?q=${encodeURIComponent(query)}&type=product`)
          : window.theme.url('/search?q=*&type=product');
      }

      clearTimeout(this.debounceTimer);

      if (query.length < 2) {
        this.showIdleState();
        return;
      }

      this.debounceTimer = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    }

    showIdleState() {
      if (this.idleContent) this.idleContent.style.display = 'block';
      if (this.resultsContainer) this.resultsContainer.style.display = 'none';
      if (this.loadingState) this.loadingState.style.display = 'none';
      // Show bestsellers when idle
      if (this.bestsellersColumn) this.bestsellersColumn.style.display = 'flex';
    }

    showLoading() {
      if (this.idleContent) this.idleContent.style.display = 'none';
      if (this.resultsContainer) this.resultsContainer.style.display = 'none';
      if (this.loadingState) this.loadingState.style.display = 'flex';
      // Hide bestsellers when loading/searching
      if (this.bestsellersColumn) this.bestsellersColumn.style.display = 'none';
    }

    showResults() {
      if (this.idleContent) this.idleContent.style.display = 'none';
      if (this.loadingState) this.loadingState.style.display = 'none';
      if (this.resultsContainer) this.resultsContainer.style.display = 'block';
      // Hide bestsellers when showing results
      if (this.bestsellersColumn) this.bestsellersColumn.style.display = 'none';
    }

    async performSearch(query) {
      this.showLoading();

      try {
        // Via window.theme.url, anders levert Shopify op /de de Nederlandse titels en links.
        const response = await fetch(
          window.theme.url('/search/suggest.json') + `?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`
        );

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        const products = (data.resources?.results?.products || []).filter(product => !window.theme.isGermanExcluded(product));

        this.showResults();

        if (products.length === 0) {
          this.resultsList.innerHTML = `
            <div class="adeqo-search-drawer__no-results">
              Geen resultaten gevonden voor "${query}"
            </div>
          `;
          return;
        }

        // Render results
        this.resultsList.innerHTML = products.map(product => `
          <a href="${product.url}" class="adeqo-search-drawer__result-item">
            <div class="adeqo-search-drawer__result-image">
              ${product.featured_image?.url
                ? `<img src="${product.featured_image.url}&width=100" alt="${product.title}" loading="lazy">`
                : ''
              }
            </div>
            <div class="adeqo-search-drawer__result-info">
              <span class="adeqo-search-drawer__result-title">${product.title}</span>
              <span class="adeqo-search-drawer__result-price">${this.formatMoney(product.price)}</span>
            </div>
          </a>
        `).join('');

      } catch (error) {
        console.error('Search error:', error);
        this.resultsList.innerHTML = `
          <div class="adeqo-search-drawer__no-results">
            Er ging iets mis. Probeer het opnieuw.
          </div>
        `;
      }
    }

    formatMoney(price) {
      // /search/suggest.json levert de prijs al in hele euro's (bv. "119.95"), niet in centen.
      const amount = parseFloat(price).toFixed(2).replace('.', ',');
      return `€${amount}`;
    }

    truncateText(text, maxLength) {
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    }
  }

  customElements.define('search-drawer', SearchDrawer);

  // Global access for header triggers
  window.adeqoSearchDrawer = {
    open() {
      document.querySelector('search-drawer')?.open();
    },
    openFromMenu() {
      document.querySelector('search-drawer')?.openFromMenu();
    },
    close() {
      document.querySelector('search-drawer')?.close();
    }
  };
})();

  } catch(e) { console.error(e); }
})();
})();
